import React, { useContext, useState } from "react";
import { ButtonProps, EditButton, Aside } from "sprint-common-web";

import { EpisodePageContext } from "../../context/EpisodePageProvider";
import { EditEpisodeForm, UpdatedEpisodeData } from "../edit-episode-form/EditEpisodeForm";

export type EditEpisodeButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    episodeId: string;
    isLabeled?: boolean;
};

export const EditEpisodeButton: React.FunctionComponent<EditEpisodeButtonProps> = (props: EditEpisodeButtonProps) => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const { updateEpisode, selectedSeason } = useContext(EpisodePageContext);

    const handleClick = () => {
        setIsAsideOpen(true);
    };

    const handleEditEpisodeFormSubmit = (updatedEpisodeData: UpdatedEpisodeData) => {
        updateEpisode(updatedEpisodeData.title, updatedEpisodeData.number);
        setIsAsideOpen(false);
    };

    const closeEditEpisodeSidebar = () => {
        setIsAsideOpen(false);
    };

    return (
        <>
            <EditButton onClick={handleClick} isLabeled={props.isLabeled} testId="edit-episode" />
            <Aside isOpen={isAsideOpen} type="form" headerText="Edit Episode" onDismiss={closeEditEpisodeSidebar}>
                <EditEpisodeForm
                    onCancel={closeEditEpisodeSidebar}
                    onSubmit={handleEditEpisodeFormSubmit}
                    selectedEpisodeId={props.episodeId}
                    selectedSeasonId={selectedSeason.id}
                />
            </Aside>
        </>
    );
};
